import React from 'react';

type NotificationBannerProps = {
  description: string;
  buttonText: string;
  buttonAction: () => void;
};

export const NotificationBanner = ({
  description,
  buttonText,
  buttonAction,
}: NotificationBannerProps) => {
  return (
    <div className="row">
      <div className="col-md-12 flex">
        <div className="modal-body">
          <p>{description}</p>
        </div>
        <div className="modal-footer">
          <div className="row follow_container">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => buttonAction()}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
